import { Injectable } from '@angular/core';
import { RequestData } from 'src/app/common/models/request-data.model';
import { Observable, of } from 'rxjs';
import { environment } from 'src/environments/environment';
import { HttpClient, HttpHeaders } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class WeeklyReportService {

  


  constructor(private http: HttpClient) { }
    
    
    getWeekNoList(requestData:RequestData): Observable<any> {
      return this.http.post(environment.baseUrl+'/week-def/get', requestData);
  
    }

    getWeekNoExportList(data: any): Observable<any> {
      // Add responseType: 'blob' to indicate you expect a binary response
      return this.http.post(
        environment.baseUrl+'/shop/reports/export-weekly-report', 
        data, 
        { responseType: 'blob' }
  );
  }

  
}
